<template>
  <div class="ems-page team-selection">
    <NavBar class="mb-4 nav-bar-text">
      <template #left>
        <BackLink v-if="showBackLink()" data-testid="team-back-button" />
      </template>

      <template #center>
        <span class="page-title"> Choose your team </span>
      </template>

      <template #right>
        <b-nav-item data-testid="button-next" :disabled="!selectedTeam" @click="next">
          <span
            :class="{
              'next-enabled': selectedTeam,
              'next-disabled': !selectedTeam,
            }"
          >
            Next
          </span>
        </b-nav-item>
      </template>
    </NavBar>

    <b-container class="h-100">
      <b-row align-h="center" class="pb-4 pt-2">
        <b-col>
          <b-list-group>
            <b-list-group-item
              v-for="team in teams"
              :key="team.id"
              class="item-row"
              @click="teamSelected(team, $event)"
            >
              <b-form-radio
                v-if="team.hospitals.length > 0"
                v-model="selectedTeam"
                class="team"
                :data-testid="`radio-button-team-${team.name}`"
                name="teams"
                :value="team.id"
                >{{ team.name }}
              </b-form-radio>
              <div v-else class="team-without-hospitals">{{ team.name }}</div>
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>
    </b-container>

    <shift :show-navbar="false" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import BackLink from "@/App/components/BackLink.vue";
import NavBar from "@/App/components/NavBar.vue";
import Shift from "@/Shift/ui/Shift.vue";

export default {
  name: "TeamSelection",

  components: { BackLink, NavBar, Shift },

  data() {
    return {
      selectedTeam: null,
      selectedTeamOriginalId: null,
      teamChanged: null,
    };
  },

  computed: {
    ...mapGetters("Login", ["teams", "user"]),
    ...mapGetters("TeamSelection", {
      selectedTeamOriginalStore: "selectedTeam",
    }),
  },
  mounted: function () {
    if (this.selectedTeamOriginalId === null && this.selectedTeamOriginalStore) {
      this.selectedTeamOriginalId = this.selectedTeamOriginalStore.id;
    }
  },
  methods: {
    ...mapActions("TeamSelection", ["selectTeam"]),
    ...mapActions("PubNubSubscription", [
      "subscribeHospitalsChannels",
      "unsubscribeHospitalsChannels",
      "setupBroadcastMessagesAndSubscriptions",
    ]),

    showBackLink() {
      return !this.selectedTeamOriginalId || this.teamChanged ? false : true;
    },

    teamSelected(team, evt) {
      if (evt.target.nodeName === "LABEL") {
        return;
      }
      if (team.hospitals.length === 0) {
        return;
      }

      this.selectedTeam = team.id;

      this.teamChanged = this.selectedTeamOriginalId !== team.id;

      this.selectTeam(team);
    },

    next() {
      if (this.selectedTeam === null) {
        alert("You must select a team!");
      }

      if (this.teamChanged) {
        this.setupBroadcastMessagesAndSubscriptions({
          uuid: this.user.id,
          hospitals: this.selectedTeamOriginalStore.hospitals,
        });
      }

      this.$router.push({ name: "truck-selection" });
    },
  },
};
</script>

<style scoped>
.item-row {
  padding: 0;
}

.nav-bar-text {
  color: white;
}

.next-disabled {
  cursor: not-allowed;
}

.next-enabled {
  color: red;
  cursor: pointer;
}

.page-title {
  color: red;
  font-weight: bold;
}

.team {
  padding: 12px 20px 12px 44px;
}

.team-selection {
  color: black;
  text-align: left;
}

.team-without-hospitals {
  color: #444;
  cursor: not-allowed;
  padding: 12px 20px 12px 44px;
}

.team-without-hospitals:after {
  content: " \26a0 This team has no hospitals!";
  color: #666;
  font-size: 0.75rem;
}
</style>
